module.exports = __webpack_public_path__ + "static/media/food-truck-line-share.ad10eff9.png";